// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "preline/dist/preline.js";
import "./controllers"

function addMultipleEventListeners(element, events, handler, options) {
  events.forEach(event => element.addEventListener(event, handler, options));
}

addMultipleEventListeners(document, ['turbo:before-stream-render', 'turbo:load'], (e) => {
  setTimeout(() => {
    HSAccordion.autoInit();
    HSDropdown.autoInit();
    HSOverlay.autoInit();
    HSSelect.autoInit();
    HSTooltip.autoInit();
    HSRemoveElement.autoInit();
    HSCollapse.autoInit();
  }, 50);
});
